import { combineReducers } from "redux";
import { ReportsConfig } from "../../interfaces/ReportsConfigInterface";

import * as actionTypes from "../actions/types";

const initialUserState = {
  currentUser: null,
  isLoggedIn: null,
};

const initialAutosuggestState = {
  users: null,
};

const initialCustomerState = () => {
  const storedData = localStorage.getItem("currentCustomer");
  if (!storedData) {
    return { currentCustomer: null };
  }
  try {
    return { currentCustomer: JSON.parse(storedData) };
  } catch (error) {
    console.error("Invalid JSON in localStorage:", error);
    return { currentCustomer: null };
  }
};

const initialCustomersState = {
  customers: [],
};

const initialAlertState = {
  open: false,
  text: "",
  severity: "success",
};

const initialVehicleTemplateState = {
  template: [],
};

// to be cleaned
const initialDevice1State = {
  device1: "",
};

const initialDevice2State = {
  device2: "",
};

const initialVehicleState = {
  vehicle: "",
};

const initialDeviceState = {
  device: "",
};

const initialPageState = {
  page: 1,
};

const initialTemplateState = {
  parameters: [],
};

const initialReportsConfigState = {
  configToEdit: null as null | ReportsConfig,
};

const user_reducer = (state = initialUserState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        currentUser: action.payload.currentUser,
        isLoggedIn: true,
      };
    case actionTypes.CLEAR_USER:
      return {
        currentUser: null,
        isLoggedIn: false,
      };
    case actionTypes.RESET_USER:
      return {
        currentUser: state.currentUser,
        isLoggedIn: null,
      };
    default:
      return state;
  }
};

const autosuggest_reducer = (state = initialAutosuggestState, action) => {
  switch (action.type) {
    case actionTypes.SET_AUTOSUGGEST_DATA:
      return {
        [action.payload.collection]: action.payload.data,
      };
    case actionTypes.RESET_AUTOSUGGEST_DATA:
      return {
        [action.payload.collection]: null,
      };
    case actionTypes.RESET_AUTOSUGGEST_STATE:
      return { ...initialAutosuggestState };
    default:
      return state;
  }
};

const customer_reducer = (state = initialCustomerState, action) => {
  switch (action.type) {
    case actionTypes.SET_CUSTOMER:
      return {
        currentCustomer: action.payload.currentCustomer,
      };
    default:
      return state;
  }
};

const customers_reducer = (state = initialCustomersState, action) => {
  switch (action.type) {
    case actionTypes.SET_CUSTOMERS:
      return {
        customers: action.payload.customers,
      };
    default:
      return state;
  }
};

const alert_reducer = (state = initialAlertState, action) => {
  switch (action.type) {
    case actionTypes.SET_ALERT:
      return {
        ...action.payload,
      };
    case actionTypes.CLEAR_ALERT:
      return {
        open: false,
        text: "",
        severity: "success",
      };
    default:
      return state;
  }
};

const vehicle_template_reducer = (
  state = initialVehicleTemplateState,
  action,
) => {
  switch (action.type) {
    case actionTypes.SET_VEHICLE_TEMPLATE:
      return {
        ...action.payload,
      };
    case actionTypes.CLEAR_VEHICLE_TEMPLATE:
      return {
        template: [],
      };
    default:
      return state;
  }
};

// to be cleaned
const device1_reducer = (state = initialDevice1State, action) => {
  switch (action.type) {
    case actionTypes.SET_DEVICE1:
      return {
        device1: action.payload.device1,
      };
    default:
      return state;
  }
};

const device2_reducer = (state = initialDevice2State, action) => {
  switch (action.type) {
    case actionTypes.SET_DEVICE2:
      return {
        device2: action.payload.device2,
      };
    default:
      return state;
  }
};

const vehicle_reducer = (state = initialVehicleState, action) => {
  switch (action.type) {
    case actionTypes.SET_VEHICLE:
      return {
        vehicle: action.payload.vehicle,
      };
    default:
      return state;
  }
};

const device_reducer = (state = initialDeviceState, action) => {
  switch (action.type) {
    case actionTypes.SET_DEVICE:
      return {
        device: action.payload.device,
      };
    default:
      return state;
  }
};

const page_reducer = (state = initialPageState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE:
      return {
        page: action.payload.page,
      };
    default:
      return state;
  }
};

const template_reducer = (state = initialTemplateState, action) => {
  switch (action.type) {
    case actionTypes.SET_TEMPLATE_PARAMETERS:
      return {
        parameters: action.payload.parameters,
      };
    default:
      return state;
  }
};

const reports_config_reducer = (state = initialReportsConfigState, action) => {
  switch (action.type) {
    case actionTypes.SET_REPORT_CONFIG_TO_EDIT:
      return {
        configToEdit: action.payload.config,
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  user: user_reducer,
  customer: customer_reducer,
  customers: customers_reducer,
  alert: alert_reducer,
  vehicleTemplate: vehicle_template_reducer,
  device1: device1_reducer,
  device2: device2_reducer,
  vehicle: vehicle_reducer,
  device: device_reducer,
  page: page_reducer,
  parameters: template_reducer,
  autosuggest: autosuggest_reducer,
  reportsConfig: reports_config_reducer,
});

export default rootReducer;
